import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faAddressCard,
  faArrowLeft,
  faArrowRight,
  faArrowsRotate,
  faArrowUpRightFromSquare,
  faBagShopping,
  faBan,
  faBars,
  faBook,
  faBullhorn,
  faCalculator,
  faCalendarCheck,
  faCar,
  faCheck,
  faCheckDouble,
  faChevronDown,
  faChevronLeft,
  faChevronRight,
  faChevronUp,
  faCircle,
  faCircleCheck,
  faCircleDot,
  faCircleExclamation,
  faCircleInfo,
  faClock,
  faCode,
  faComment,
  faCopy,
  faDownLeftAndUpRightToCenter,
  faDownload,
  faEyeSlash,
  faFileArrowDown,
  faFileCirclePlus,
  faFileLines,
  faFilter,
  faGear,
  faHashtag,
  faImage,
  faLink,
  faMagnifyingGlass,
  faMapLocationDot,
  faMicrophone,
  faMinus,
  faNoteSticky,
  faPaperclip,
  faPaperPlane,
  faPen,
  faPhone,
  faPlus,
  faPowerOff,
  faQrcode,
  faRectangleList,
  faReply,
  faRobot,
  faRotateLeft,
  faSearch,
  faShare,
  faShareNodes,
  faSquare,
  faSquareCheck,
  faStop,
  faSliders,
  faTimes,
  faToggleOn,
  faToggleOff,
  faTrash,
  faTriangleExclamation,
  faUpRightAndDownLeftFromCenter,
  faUser,
  faUserGear,
  faVideo,
  faWindowMinimize,
} from '@fortawesome/free-solid-svg-icons';

import {
  faCircle as faCircleRegular,
  faCopy as faCopyRegular,
  faSquare as faSquareRegular,
  faWindowMaximize,
} from '@fortawesome/free-regular-svg-icons';

import {
  faWhatsapp as faWhatsApp,
  faFacebookF as faFacebook,
  faFacebookMessenger,
  faInstagram,
  faTiktok as faTikTok,
} from '@fortawesome/free-brands-svg-icons';

library.add(faAddressCard);
library.add(faArrowLeft);
library.add(faArrowRight);
library.add(faArrowsRotate);
library.add(faArrowUpRightFromSquare);
library.add(faBagShopping);
library.add(faBan);
library.add(faBars);
library.add(faBook);
library.add(faBullhorn);
library.add(faCalculator);
library.add(faCalendarCheck);
library.add(faCar);
library.add(faCheck);
library.add(faCheckDouble);
library.add(faChevronDown);
library.add(faChevronLeft);
library.add(faChevronRight);
library.add(faChevronUp);
library.add(faCircle);
library.add(faCircleRegular);
library.add(faCircleCheck);
library.add(faCircleDot);
library.add(faCircleExclamation);
library.add(faCircleInfo);
library.add(faClock);
library.add(faCode);
library.add(faComment);
library.add(faCopy);
library.add(faCopyRegular);
library.add(faDownLeftAndUpRightToCenter);
library.add(faDownload);
library.add(faEyeSlash);
library.add(faFileArrowDown);
library.add(faFileCirclePlus);
library.add(faFileLines);
library.add(faFilter);
library.add(faGear);
library.add(faHashtag);
library.add(faImage);
library.add(faLink);
library.add(faMagnifyingGlass);
library.add(faMapLocationDot);
library.add(faMicrophone);
library.add(faMinus);
library.add(faNoteSticky);
library.add(faPaperclip);
library.add(faPaperPlane);
library.add(faPen);
library.add(faPhone);
library.add(faPlus);
library.add(faPowerOff);
library.add(faQrcode);
library.add(faRectangleList);
library.add(faReply);
library.add(faRobot);
library.add(faRotateLeft);
library.add(faSearch);
library.add(faShare);
library.add(faShareNodes);
library.add(faSquare);
library.add(faSquareCheck);
library.add(faStop);
library.add(faSquareRegular);
library.add(faSliders);
library.add(faTimes);
library.add(faToggleOn);
library.add(faToggleOff);
library.add(faTrash);
library.add(faTriangleExclamation);
library.add(faUpRightAndDownLeftFromCenter);
library.add(faUser);
library.add(faUserGear);
library.add(faVideo);
library.add(faWindowMaximize);
library.add(faWindowMinimize);

library.add(faFacebook);
library.add(faFacebookMessenger);
library.add(faInstagram);
library.add(faTikTok);
library.add(faWhatsApp);
